import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Sheet } from '../ui/Sheet';
import { AnimatedCheck } from '../ui/AnimatedCheck';
import { Button } from '../ui/Button';
import { UploadPanel } from './UploadPanel';
import { usePortal } from '../../contexts/PortalContext';
import { processor } from '../../data/team';
import type { DocumentItem } from '../../types/application';
import { useTokens } from '../../hooks/useTokens';
interface DocumentUploadSheetProps {
  doc: DocumentItem | null;
  onClose: () => void;
}
export function DocumentUploadSheet({
  doc,
  onClose
}: DocumentUploadSheetProps) {
  const {
    uploadDocument
  } = usePortal();
  const [done, setDone] = useState(false);
  const {
    fill
  } = useTokens();
  useEffect(() => {
    if (doc) setDone(false);
  }, [doc]);
  return <Sheet open={!!doc} onClose={onClose} title={done ? 'Uploaded' : doc?.status === 'attention' ? `Replace ${doc?.name.toLowerCase()}` : doc?.name ?? ''} description={done || !doc ? undefined : fill(doc.reason)} data-id="element-413" data-mp="3vj3rh2vufidp">
      {doc && !done && <>
          {doc.note && <p className="mb-4 rounded-xl bg-critical-50 px-4 py-3 text-sm text-critical-700" data-id="element-414" data-mp="2hwrguq5v28hx">{doc.note}</p>}
          <UploadPanel sampleName={`${doc.id}.pdf`} onSubmit={names => {
        uploadDocument(doc.id, names);
        setDone(true);
      }} data-id="element-415" data-mp="2mnhoka1renfs" />
        </>}
      {doc && done && <div className="flex flex-col items-center py-4 text-center" data-id="element-416" data-mp="1uymv8gmfq8bp">
          <AnimatedCheck size={56} data-id="element-417" data-mp="1yzggt3cenb1f" />
          <motion.p initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.25
      }} className="mt-5 text-lg font-semibold text-ink-900" data-id="element-418" data-mp="1z0huzgopwdnd">
            Got it — thanks!
          </motion.p>
          <motion.p initial={{
        opacity: 0,
        y: 6
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: 0.3
      }} className="mt-1 max-w-xs text-sm text-ink-500" data-id="element-419" data-mp="28u8iai93yi1h">
            {processor.firstName} will review your {doc.name.toLowerCase()} within 1 business day. We’ll text you if anything else is needed.
          </motion.p>
          <Button className="mt-6" variant="secondary" onClick={onClose} data-id="element-420" data-mp="2porpwixyvu5u">
            Done
          </Button>
        </div>}
    </Sheet>;
}